import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'


declareVconsoleComponent('stripeAdmin', () => import('./components/StripeAdmin.vue'), 'stripe_admin:page')